// extracted by mini-css-extract-plugin
export default {"icon":"J_cy"};